var _circle, _circle2, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "black",
    fillOpacity: 0.12
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12,
    fill: "#39BAB5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9520_83156",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 18,
    height: 18,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9520_83156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6875 19.975L12.5312 17.8187C12.3937 17.6812 12.325 17.5125 12.325 17.3125C12.325 17.1125 12.4 16.9375 12.55 16.7875C12.6875 16.65 12.8625 16.578 13.075 16.5715C13.2875 16.5655 13.4625 16.6375 13.6 16.7875L15.2125 18.3625L18.925 14.65C19.0625 14.5125 19.2342 14.4438 19.4402 14.4438C19.6467 14.4438 19.825 14.5188 19.975 14.6688C20.125 14.8188 20.197 15 20.191 15.2125C20.1845 15.425 20.1062 15.6063 19.9562 15.7563L15.7375 19.975C15.6 20.1125 15.425 20.1813 15.2125 20.1813C15 20.1813 14.825 20.1125 14.6875 19.975ZM7 19C6.5875 19 6.2345 18.8533 5.941 18.5598C5.647 18.2658 5.5 17.9125 5.5 17.5V8.5C5.5 8.0875 5.647 7.7345 5.941 7.441C6.2345 7.147 6.5875 7 7 7H19C19.4125 7 19.7658 7.147 20.0598 7.441C20.3533 7.7345 20.5 8.0875 20.5 8.5V13H18.4562L15.2125 16.2438L14.6875 15.7188C14.25 15.2813 13.7187 15.0625 13.0938 15.0625C12.4688 15.0625 11.9375 15.2813 11.5 15.7188C11.0625 16.1562 10.8407 16.6845 10.8347 17.3035C10.8282 17.922 11.0438 18.45 11.4813 18.8875L11.5938 19H7ZM7 13H19V10H7V13Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPos);
export default __webpack_public_path__ + "static/media/pos.158e71b690ab1babd31df44127593624.svg";
export { ForwardRef as ReactComponent };